import { SectionEditModalForm } from "./SectionEditModalForm"


const SectionEditModalFormWrapper = () => {
    return (<SectionEditModalForm />)
}

export {SectionEditModalFormWrapper}